<template>
  <div>
    <ed-risco :intRiscoId="$route.params.intId" :key="$root.$session.versao"/>
  </div>
</template>

<script>
import EdRisco from "@/components/cadastro/risco/editar";

export default {
  name: "pageCadastroEmpresa",
  props: {},
  components: {EdRisco },
  mounted() {
    if(!this.$route.params.intId){
      this.$router.push({ name: "cadastro.risco.register" });
    }
  },
  created() {},
  data() {
    return {
    };
  },
  methods: {
  
  },
};
</script>